"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../../../shared");

var HeadCell_meta_1 = require("./HeadCell.meta");

var TableComponentBase_1 = require("../TableComponentBase");

var Translate_1 = __importDefault(require("../../../Translate"));

var HeadCellSubTitle_1 = __importDefault(require("../../styledComponents/HeadCellSubTitle"));

var Tooltip_1 = __importDefault(require("../../../Tooltip"));

var SortButton_1 = __importDefault(require("../../../SortButton"));

var Translate_2 = require("../../../Translate/Translate");

var mobx_1 = require("mobx");

var VisuallyHidden_1 = __importDefault(require("../../../VisuallyHidden"));

var HeadCell =
/** @class */
function (_super) {
  __extends(HeadCell, _super);

  function HeadCell(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = HeadCell_meta_1.HEAD_CELL_CATEGORY_KEY;
    _this.componentKey = HeadCell_meta_1.HEAD_CELL_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(HeadCell.prototype, "parentComponentKey", {
    get: function get() {
      return HeadCell_meta_1.HEAD_CELL_PARENT_COMPONENT_KEY;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HeadCell.prototype, "tableEventsKey", {
    get: function get() {
      return 'headerCell';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HeadCell.prototype, "headerText", {
    get: function get() {
      var column = this.props.column;
      var _a = column.header,
          header = _a === void 0 ? '' : _a,
          hideHeader = column.hideHeader,
          headerDisplay = column.headerDisplay;
      var headerComponent = headerDisplay ? this.table.logic.getHeaderValue(headerDisplay) : react_1.default.createElement(Translate_1.default, null, header);

      if (hideHeader) {
        return react_1.default.createElement(VisuallyHidden_1.default, null, headerComponent);
      }

      return headerComponent;
    },
    enumerable: true,
    configurable: true
  });

  HeadCell.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        configuration = _a.configuration,
        componentStyle = _a.componentStyle,
        componentStyleProps = _a.componentStyleProps,
        table = _a.table,
        rowIndex = _a.rowIndex,
        column = _a.column,
        columnIndex = _a.columnIndex,
        otherProps = __rest(_a, ["children", "configuration", "componentStyle", "componentStyleProps", "table", "rowIndex", "column", "columnIndex"]);

    var _b = column.header,
        header = _b === void 0 ? '' : _b,
        subTitle = column.subTitle,
        headCellSubTitleStyle = column.headCellSubTitleStyle,
        headerDisplay = column.headerDisplay;
    var cellKey = this.getHeadCellKey(rowIndex, columnIndex, column);
    var tooltip = this.getTooltipHeaderProps(column, {
      target: 'header'
    });
    var subTitleTooltip = this.getTooltipHeaderProps(column, {
      target: 'subtitle'
    });
    var events = this.getEvents(this.eventsForElement, undefined, rowIndex, column, columnIndex, header);
    var sortEnabled = column && column.sort && column.sort.enabled;
    return react_1.default.createElement(Translate_2.TranslationContext.Consumer, null, function (translationContext) {
      var ariaProps = {};

      if (!tooltip && !subTitle && !sortEnabled) {
        return react_1.default.createElement("th", __assign({}, events, otherProps), _this.headerText);
      }

      if (header) {
        // set up aria-label so that VO announces just the header instead of the tooltips as well
        ariaProps['aria-label'] = translationContext.translate(header);
      }

      return react_1.default.createElement("th", __assign({}, events, otherProps), react_1.default.createElement("div", __assign({}, ariaProps), (header || headerDisplay) && _this.headerText, tooltip && react_1.default.createElement(Tooltip_1.default, __assign({}, tooltip)), subTitle && react_1.default.createElement(HeadCellSubTitle_1.default, {
        key: cellKey + "_subTitle",
        componentStyle: headCellSubTitleStyle
      }, react_1.default.createElement(Translate_1.default, null, subTitle), subTitleTooltip && react_1.default.createElement(Tooltip_1.default, __assign({}, subTitleTooltip))), column && column.sort && sortEnabled && react_1.default.createElement(SortButton_1.default, __assign({}, column.sort, {
        payload: column
      }, table.sortingDirections[column.id] || {}, {
        onChange: table.wrapSort(column.sort.onChange)
      }))));
    });
  };

  __decorate([mobx_1.computed], HeadCell.prototype, "headerText", null);

  HeadCell = __decorate([mobx_react_1.observer], HeadCell);
  return HeadCell;
}(TableComponentBase_1.TableComponentBase);

exports.HeadCell = HeadCell;
exports.default = shared_1.InjectedStyledComponent(HeadCell, HeadCell_meta_1.HEAD_CELL_CATEGORY_KEY, HeadCell_meta_1.HEAD_CELL_PARENT_COMPONENT_KEY, [HeadCell_meta_1.HEAD_CELL_COMPONENT_KEY]);